import { translate } from 'hooks/useTranslate';
import { boardDelegationRoles } from 'modules/boards/constants/boardDelegation';
import { getBoardRepresentants } from 'modules/boards/utils/getBoardRepresentants';
import { Board, Partner, PartnerRepresentant } from 'types';

type Options = {
  role: string;
  value: string;
  label: string;
  disabled: boolean;
};

type SelectedPartnerOptions = {
  label: string;
  options: Options[];
};

export const getSelectedPartnerOptions = (
  partners: Partner[],
  board: Board,
  partnerRepresentants: PartnerRepresentant[]
): SelectedPartnerOptions[] => {
  const participantsByMemberId = new Map(
    (board?.participants || []).map((participant) => [participant.member, participant])
  );

  const partnerOptions = partners.map((partner) => ({
    role: boardDelegationRoles.PARTNER,
    value: partner['_id'],
    label: `${partner?.cif} | ${partner?.name}`,
    disabled:
      participantsByMemberId.get(partner['_id'])?.isRepresented ||
      (participantsByMemberId.get(partner['_id'])?.votes?.length || 0) > 0,
  }));

  const representants = getBoardRepresentants(board, partnerRepresentants);

  const representantOptions = representants.map((representant) => ({
    role: boardDelegationRoles.PARTNER_REPRESENTANT,
    value: representant['_id'],
    label: `${representant?.cif} | ${representant?.name}`,
    disabled: false,
  }));

  return [
    { label: translate('PartnerRepresentants'), options: representantOptions },
    { label: translate('Partners'), options: partnerOptions },
  ];
};
